import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { Article } from "../../models/article.model";
import { EntityApiService } from "../../../../shared/store/entity-store/entity-api.service";
import { environment } from "environments/environment";
import { SpecifDuplicatePayload } from "../../models/article-payload-duplicate.model";
import { SpecificationEtape } from "../../../specifications/models/specification-etape.model";
import { StatsArticle } from "../../models/stats-article.model";

@Injectable({ providedIn: "root" })
export class ArticleApiService implements EntityApiService<Article> {
  http = inject(HttpClient);

  loadOne(id: string): Observable<Article> {
    return this.http.get<Article>(`${environment.api()}/articles/id/${id}`);
  }

  create(entity: Article): Observable<Article> {
    return this.http.post<Article>(
      `${environment.api()}/articles/withInfos`,
      entity,
    );
  }

  remove(id: string): Observable<string> {
    return this.http
      .delete(`${environment.api()}/articles/${id}`)
      .pipe(map((a) => id));
  }

  update(entity: Article): Observable<Article> {
    return this.http.post<Article>(
      `${environment.api()}/articles/id/${entity.id}`,
      entity,
    );
  }

  loadAll(): Observable<Article[]> {
    return this.http.get<Article[]>(`${environment.api()}/articles/`);
  }

  duplicate(payload: SpecifDuplicatePayload) {
    return this.http.post<{
      specificationEtape: SpecificationEtape;
      article: Article;
    }>(`${environment.api()}/articles/duplicate_article`, payload);
  }

  stats(payload: { articleId: string; dateDebut: Date; dateFin: Date }) {
    return this.http.post<StatsArticle>(
      `${environment.api()}/stats/article`,
      payload,
    );
  }
}
